import axiosClient from './axios-client';

const authorApi = {
  logout() {
    return axiosClient({
      method: 'POST',
      url: '/customer/logout',
    });
  },
  login(data: any) {
    return axiosClient({
      url: '/customer/login',
      method: 'POST',
      data,
    });
  },
  register(data: any) {
    return axiosClient({
      url: '/customer',
      method: 'POST',
      data,
    });
  },
  loginPasswordless(data: any) {
    return axiosClient({
      url: '/customer/login-passwordless',
      method: 'POST',
      data,
    });
  },
  validateEmail(data: any) {
    return axiosClient({
      url: '/customer/check-duplicate-email',
      method: 'POST',
      data,
    });
  },
  forgotPassword(email: string, locale?: any, tokenCaptcha?: any) {
    return axiosClient({
      url: '/customer/forgot-password',
      method: 'POST',
      data: {email: email, locale: locale ?? '', tokenCaptcha},
    });
  },
};

export default authorApi;
